import React, { useState } from 'react';
import { FiLock } from 'react-icons/fi';
import toast from 'react-hot-toast';

const PinModal = ({ isOpen, onClose, onConfirm, title = "Code PIN requis", message = "Cette action nécessite un code PIN" }) => {
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  
  if (!isOpen) return null;
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    if (pin === '020260') {
      try {
        await onConfirm();
        setPin('');
        onClose();
      } catch (error) {
        console.error('Erreur:', error);
        toast.error('Erreur lors de l\'exécution');
      }
    } else {
      toast.error('Code PIN incorrect');
    }
    setLoading(false);
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
            <FiLock className="text-green-600" size={20} />
          </div>
          <h2 className="text-xl font-semibold">{title}</h2>
        </div>
        <p className="text-gray-600 mb-4">{message}</p>
        <form onSubmit={handleSubmit}>
          <input type="password" placeholder="Code PIN à 6 chiffres" className="input-field mb-2" value={pin} onChange={(e) => setPin(e.target.value)} maxLength={6} autoFocus />
          <div className="flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 btn-secondary">Annuler</button>
            <button type="submit" disabled={loading} className="flex-1 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700">{loading ? 'Vérification...' : 'Confirmer'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PinModal;